import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { RawHtml, ContentBlock } from '../../../../../components/common/';
import UsefulLinksHP from '../UsefulLinks/UsefulLinksHP.jsx';
import CalendarAgenda from '../CalendarAgenda/CalendarAgenda';
import { useTranslation } from 'react-i18next';
import { routes } from '../../../../../utils/helpers/ApiClient';
import ControlsActions from '../../../../common/controls/ControlsActions/ControlsActions';
import { BLOCKS_PREDEFINED } from '../../../../../utils/constants/enums.js';
import { toggleBlockVisibility } from '../../../../../redux/slices/localStorageSlice';
import { MeteoStationBlock } from '../MeteoStationBlock/MeteoStationBlock';

const PositionBlock = ({ blocks, position, contentWrapper }) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const isEnglish = i18n.language === 'en';

  const closedHomePageBlocks = useSelector(
    (s) => s.localStorage.closedHomePageBlocks,
  );

  const blocksForThisPosition = useMemo(() => {
    return (
      blocks &&
      blocks
        .filter((singleBlock) => {
          const positionForLanguage = isEnglish
            ? singleBlock.position_en
            : singleBlock.position_sk;
          return position === positionForLanguage;
        })
        .sort((a, b) => {
          const orderField = isEnglish ? 'order_en' : 'order_sk';
          if (a[orderField] < b[orderField]) {
            return -1;
          }
          if (a[orderField] > b[orderField]) {
            return 1;
          }
          return 0;
        })
    );
  }, [blocks, isEnglish, position]);

  const getBlockContent = (block) => {
    switch (block.generated_content) {
      case BLOCKS_PREDEFINED.BLOCK_CALENDAR:
        return <CalendarAgenda blocksId={block.id} />;
      case BLOCKS_PREDEFINED.BLOCK_USEFUL_LINK:
        return <UsefulLinksHP isEnglish={isEnglish} />;
      case BLOCKS_PREDEFINED.BLOCK_WEATHER:
        return <MeteoStationBlock />;
      default:
        return (
          <>
            <ControlsActions
              moveToTop
              actions={[
                {
                  to: `${routes.cmsBlocksEdit}/${block.id}`,
                  permission: 'blocks.update',
                },
              ]}
            />
            <RawHtml>{isEnglish ? block.content_en : block.content_sk}</RawHtml>
          </>
        );
    }
  };

  return (
    <div className="block-component-wrapper">
      {(blocksForThisPosition || []).map((block) => (
        <ContentBlock
          titleToggle={(title) => dispatch(toggleBlockVisibility(title))}
          showable
          contentVisible={
            !closedHomePageBlocks.includes(
              isEnglish ? block.label_en : block.label_sk,
            )
          }
          contentWrapper={`add-icons-to-file-anchors ${contentWrapper}`}
          key={block.id}
          title={isEnglish ? block.label_en : block.label_sk}
        >
          {getBlockContent(block)}
        </ContentBlock>
      ))}
    </div>
  );
};

PositionBlock.propTypes = {
  position: PropTypes.number.isRequired,
  blocks: PropTypes.array,
  jobOffers: PropTypes.array,
  contentWrapper: PropTypes.string,
};

export default PositionBlock;
